import { DcBaseComponent } from '@deleteagency/dc';
import { eventBus, events } from 'general/js/events';
import { EVENT_INPUT_UPDATED } from './events';

export default class SearchFiltersComponent extends DcBaseComponent {
    static getNamespace() {
        return 'search-filters';
    }

    static getRequiredRefs() {
        return ['resetButton'];
    }

    onInit() {
        this._getState();
        this.addListener(this.refs.resetButton, 'click', this._resetState);
        eventBus.addListener(events.EVENT_TAB_CHANGE, this._onTabChange);

        const noResultReset = $("button.reset-filters");
        if (noResultReset) {
            noResultReset.on('click', () => {
                this._noResultResetState();
            });
        }
    }

    _getState() {
        this.elements = [...this.element.elements];
        this.state = this.options.initialState;
    }

    _setState = () => {
        for (const el of this.elements) {
            if (typeof this.state[el.name] === 'undefined') continue;
            if (el.type === 'checkbox') {
                if (Array.isArray(this.state[el.name])) {
                    // Check the checkbox if its value is in the state array
                    el.checked = this.state[el.name].includes(el.value);
                } else {
                    // Otherwise, use the previous boolean logic
                    el.checked = this.state[el.name];
                }
            } else {
                el.value = this.state[el.name];
                if (el.type === 'hidden') {
                    eventBus.emit(EVENT_INPUT_UPDATED, el);
                }
            }
        }
    };

    _resetState = () => {
        const hiddenLocationInput = $('input[name="locationName"]');
        const hiddenCountyInput = $('input[name="countyName"]');
        const locationValue = hiddenLocationInput.val();
        const countyValue = hiddenCountyInput.val();
    
        this.elements.forEach(el => {
            const { name, type } = el;
            const stateValue = this.state[name];
            
            if (stateValue === undefined) return;
    
            if (type === 'checkbox') {
                el.checked = Array.isArray(stateValue) ? stateValue.includes(el.value) : stateValue;
            } else {
                el.value = stateValue;
            }
        });
    
        hiddenLocationInput.val(locationValue);
        hiddenCountyInput.val(countyValue);
    };
    
    _noResultResetState = () => {
        const resetButton = $('.filter-quick-search__reset');
        const updateResults = $('.filter-quick-search__button');
        
        if (!resetButton) {
            return;
        }
        resetButton.trigger('click');        

        setTimeout(() => {
            if (!updateResults) {
                return;
            }
            updateResults.trigger('click');
        }, 500);
    };

    _checkState = () => {
        this._setState();
        const selects = document.querySelectorAll('select');
        selects.forEach((select) => {            
            select.dispatchEvent(new Event('change'));
        });
    }

    _onTabChange = (id) => {
        const { viewTypeInput } = this.refs;
        viewTypeInput.value = id;
    };
}
